function getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

export function getCSRFToken(): string {
    return getCookie('XSRF-TOKEN') || '';
}
